import { type ExamCenterMemberType } from '@exam-center/graphql';
import { LabelColor } from '@shared/components';

export enum ExamCenterMemberStatus {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
  INVITATION_EXPIRED = 'INVITATION_EXPIRED',
  INVITATION_PENDING = 'INVITATION_PENDING',
}

export const EXAM_CENTER_MEMBER_TYPE_TEXT: Record<ExamCenterMemberType, string> = {
  MANAGER: 'ผู้จัดการศูนย์ทดสอบ',
  PROCTOR_1: 'ผู้คุมสอบประเภทที่ 1',
  PROCTOR_2: 'ผู้คุมสอบประเภทที่ 2',
};

export const EXAM_CENTER_MEMBER_STATUS_TEXT: Record<ExamCenterMemberStatus, string> = {
  ENABLED: 'Active',
  DISABLED: 'Inactive',
  INVITATION_EXPIRED: 'Expired',
  INVITATION_PENDING: 'Pending',
};

export const EXAM_CENTER_MEMBER_STATUS_COLOR: Record<ExamCenterMemberStatus, LabelColor> = {
  ENABLED: LabelColor.SUCCESS,
  DISABLED: LabelColor.GREY,
  INVITATION_EXPIRED: LabelColor.ERROR,
  INVITATION_PENDING: LabelColor.INFO,
};
